import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MUTATION_KEYS } from '../constants';
import { ApprovalDelegate, useInvalidateApprovalDelegates } from './useApprovalDelegates';

export type ReassignApprovalDelegatesPayload = {
  ids: number[];
  toDealOwnerId: number;
};

async function reassignApprovalDelegates(
  payload: ReassignApprovalDelegatesPayload
): Promise<ApprovalDelegate[]> {
  const { data } = await Http.axios.patch<ReassignApprovalDelegatesPayload, ApprovalDelegate[]>(
    '/approval-delegate/reassign',
    payload
  );
  return data;
}

/** Change the delegate (toDealOwner) for a set of existing delegations. */
export const useReassignApprovalDelegates = () => {
  const invalidate = useInvalidateApprovalDelegates();
  return useMutation(reassignApprovalDelegates, {
    mutationKey: MUTATION_KEYS.REASSIGN_APPROVAL_DELEGATES,
    onSuccess: invalidate,
  });
};
